import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { SetCredentialMutationVariables } from "../../types";

export const SET_CREDENTIAL = gql`
  mutation setCredential(
    $accessToken: String!,
    $tokenType: string!,
    $client: String!,
    $expiry: Integer!,
    $uid: String
  ) {
    setCredential(
      accessToken: $accessToken,
      tokenType: $tokenType,
      client: $client,
      expiry: $expiry,
      uid: $uid
    ) @client
  }
`;

export default (
  options?: MutationHookOptions<null, SetCredentialMutationVariables>
) => {
  return useMutation<null, SetCredentialMutationVariables>(
    SET_CREDENTIAL,
    options
  );
};
